<script lang="ts" setup>
import type { EditorialSidesheet } from '@integration-layer/ampliance/schemas/editorial-sidesheet-schema.localized'

const props = defineProps<{
  deliveryId: string
  locale: string
  vse?: string
  content?: EditorialSidesheet
}>()

const data = await useComponentResponse<EditorialSidesheet>(props)

const editorials = computed(() =>
  connectComponents(
    //@ts-ignore
    data.value?.sidesheetContent?.listOfLogicWrapper ?? [],
    props.locale,
    props.vse
  )
)
</script>

<template>
  <div v-if="data">
    <OrganismsSidebarSlide
      :id="deliveryId"
      :header-props="{
        titleText: data.sidesheetTitle ?? '',
        hasBackButton: false,
        hasCloseButton: true,
      }"
    >
      <template #body>
        <div class="flex flex-col gap-6 pb-14 pt-6">
          <AmplienceDynamicContent :components="editorials" />
          <FooterNewsLetter v-if="data.hasNewsletter" />
        </div>
      </template>
    </OrganismsSidebarSlide>
  </div>
</template>
